import { render, staticRenderFns } from "./Electrical.vue?vue&type=template&id=264f296e&"
import script from "./Electrical.vue?vue&type=script&lang=js&"
export * from "./Electrical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports